import { Injectable } from '@angular/core';
import { marked } from 'marked';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {

  constructor() {
    // Optional: Set options for marked
    marked.setOptions({
      gfm: true,
      breaks: true
    });
  }

  convert(markdown: string): any  {
    return marked(markdown);
  }
}
